import { PaginationType } from './on-pagination-button-click';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';
import { DataContainer } from '@otto-ec/tracking-bct';

export const sendTrackingEvent = (paginationType: PaginationType, newPageNumber: number) => {
    const trackingLabels: DataContainer = { review_ReviewAction: ['paging'], review_ReviewPage: [String(newPageNumber)] };
    switch (paginationType) {
        case PaginationType.FIRST:
            trackingLabels.review_ReviewPageJump = ['first'];
            break;
        case PaginationType.LAST:
            trackingLabels.review_ReviewPageJump = ['last'];
            break;
    }
    trackEvent(trackingLabels);
};
